import React from 'react'
import { tidyDisplayTitle } from 'src/utils/venueName'
import RecipePinButton from './RecipePinButton'
import MissingProductsListBadge from './MissingProductsListBadge'
import SharedMissingIngredientsListBadge from './SharedMissingIngredientsListBadge'
import GpChangedListBadge from './GpChangedListBadge'
import RecipeEconomicsStaleListBadge from './RecipeEconomicsStaleListBadge'
import RecipeGpReviewMarkReviewedLink from './RecipeGpReviewMarkReviewedLink'
import { isRecipePinned } from 'src/utils/menuBuilderPinnedRecipes'
import { recipeNeedsGpReview } from 'src/utils/recipeGpReview'
import { isRecipeArchived } from 'src/utils/recipeMonitoring'

const RecipeListItemTitle = ({
  recipe,
  duplicateCue = null,
  showMissingProductsBadge = false,
  showSharedMissingIngredientsBadge = false,
  economicsStaleContext = null,
  onTogglePin,
  onMarkReviewed,
}) => {
  const archived = isRecipeArchived(recipe)
  const showGpChangedBadge = !archived && recipeNeedsGpReview(recipe)

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
      }}
    >
      {onTogglePin ? (
        <RecipePinButton
          pinned={isRecipePinned(recipe)}
          onClick={event => {
            event.stopPropagation()
            onTogglePin(recipe)
          }}
        />
      ) : null}
      <span>{tidyDisplayTitle(recipe?.title)}</span>
      {duplicateCue ? (
        <span
          data-testid='recipe-duplicate-cue'
          style={{
            color: 'rgba(0, 0, 0, 0.45)',
            fontSize: '12px',
            fontWeight: 400,
          }}
        >
          {duplicateCue}
        </span>
      ) : null}
      {showGpChangedBadge ? <GpChangedListBadge recipe={recipe} /> : null}
      {economicsStaleContext && !archived ? (
        <RecipeEconomicsStaleListBadge
          recipe={recipe}
          economicsContext={economicsStaleContext}
        />
      ) : null}
      {showGpChangedBadge ? (
        <RecipeGpReviewMarkReviewedLink
          recipe={recipe}
          onMarkReviewed={onMarkReviewed}
        />
      ) : null}
      {showMissingProductsBadge ? <MissingProductsListBadge /> : null}
      {showSharedMissingIngredientsBadge ? (
        <SharedMissingIngredientsListBadge
          missingSharedIngredients={recipe?.missingSharedIngredients || []}
        />
      ) : null}
      {recipe?.menuInfo?.length > 0 ? (
        <div
          style={{
            display: 'flex',
            gap: '4px',
            flexWrap: 'wrap',
          }}
        >
          {recipe.menuInfo.map((menu, index) => (
            <span
              key={index}
              style={{
                fontSize: '10px',
                padding: '2px 6px',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px',
                color: '#666',
              }}
            >
              {menu.menuName}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default RecipeListItemTitle
